import React, { useState } from 'react';
import Color from 'color';

import { createUseThemedStyles } from '@/hooks';
import { LoadingButton } from '@/components';
import { ReactComponent as XIcon } from '@/assets/icons/icon-x.svg';
import { Collapse } from 'react-bootstrap';

const useStyles = createUseThemedStyles((theme) => ({
	banner: {
		position: 'relative',
		backgroundColor: theme.colors.success,
		'& .container': {
			position: 'relative',
		},
	},
	messages: {
		padding: '0 15px',
		'@media(min-width: 1175px)': {
			padding: '0 50px',
		},
	},
	message: {
		display: 'flex',
		padding: '1.2rem 0',
		alignItems: 'center',
		justifyContent: 'space-between',
		borderBottom: `1px solid ${Color(theme.colors.white)
			.alpha(0.12)
			.string()}`,
		'& p a': {
			color: theme.colors.white,
			textDecoration: 'underline',
		},
		'&:last-child': {
			borderBottom: 0,
		},
	},
}));

export const Banner = () => {
	const classes = useStyles();
	const [isShowing, setIsShowing] = useState(true);

	const handleDismissButtonClick = async () => {
		setIsShowing(false);
	};

	return (
		<Collapse in={isShowing} timeout={300}>
			<div className={classes.banner}>
				<div className={classes.messages}>
					<div className={classes.message}>
						<p className="mb-0 text-white">
							Spend Matters is now part of The Hackett Group&reg;{' '}
							<a
								href="https://www.thehackettgroup.com/spend-matters-login-has-moved/"
								target="_blank"
								rel="noreferrer"
							>
								Learn More
							</a>
							.
						</p>
						<LoadingButton
							variant="link"
							isLoading={false}
							onClick={() => {
								handleDismissButtonClick();
							}}
						>
							<XIcon className="text-white d-flex" />
						</LoadingButton>
					</div>
				</div>
			</div>
		</Collapse>
	);
};
